import {
  LAMBDATEST_ABORT_LOADING,
  LAMBDATEST_ABORT_SUCCESS,
  LAMBDATEST_ABORT_FAILED,
  LAMBDATEST_ABORT_CLEAR,
} from '../actionTypeConstants/LambdaTestAbortConstants';

const initialState = {
  testAbortState: {
    loading: false,
    data: null,
    error: null,
  },
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LAMBDATEST_ABORT_LOADING:
      return {
        ...state,
        testAbortState: {
          ...state.testAbortState,
          loading: true,
          data: null,
          error: null,
        },
      };
    case LAMBDATEST_ABORT_SUCCESS:
      return {
        ...state,
        testAbortState: {
          ...state.testAbortState,
          loading: false,
          data: action.result.data,
          error: null,
        },
      };
    case LAMBDATEST_ABORT_FAILED:
      return {
        ...state,
        testAbortState: {
          ...state.testAbortState,
          loading: false,
          error: action.error.response,
          data: null,
        },
      };
    case LAMBDATEST_ABORT_CLEAR:
      return {
        ...state,
        testAbortState: {
          loading: false,
          data: null,
          error: null,
        },
      };
    default:
      return state;
  }
}
